export const textStock = {
  textStock: {
    tableHeaders: {
      table: {
        thickness: 'Espesor(MM)',
        side1: 'Lado 1(L1)',
        side2: 'Lado 2(L2)',
        lenght: 'Largo',
        quality: 'CALIDAD',
        stock: 'PAQUETES(U)',
        specialType: 'TIPO ESPECIAL',
        group: 'GRUPO(U)',
        ancho: 'ANCHO (MM)',
        largo: 'LARGO (MM)',
        stockBobinas: 'STOCK EN BOBINAS (KG)',
        paquetes2TM: 'PAQUETES DE 2 TM (U)',
        paquetes2_5TM: 'PAQUETES DE 2,5 TM (U)',
        paquetes3TM: 'PAQUETES DE 3 TM (U)',
        rounds: 'REDONDOS',
        squares: 'CUADRADOS',
        rectangular: 'RECTANGULARES',
        specials: 'ESPECIALES',
        galvanized: 'GALVANIZADO',
        pickled: 'NEGRO/DECAPADO',
        availableStock: 'Stock Disponible',
        limitedStock: 'Stock Limitado',
        stockAvailability: 'Puedes consultar la disponibilidad de todos los productos de la tienda y añadirlos directamente al carrito.',
        noStock: 'Sin Stock'
      },
    },
  }
};
